import { OneSignalAdapter } from "./adapters/OneSignalAdapter.js";
import { Vault } from "../../../libs/storage.js";
import { Utils } from "../Utils";

interface UserTags {
  [key: string]: string | number | boolean;
}

export class PushNotifications {
  private _provider: OneSignalAdapter | null = null;
  private _eventAnchor: HTMLDivElement | null = null;
  private _utils: Utils;

  constructor(provider: string, appId: string, utils: Utils) {
    this._utils = utils;
    this._addEventAnchor();
    this._addEventListeners();

    const externalId = this._getUserExternalId();

    switch (provider) {
      default:
        this._provider = new OneSignalAdapter(
          this._eventAnchor,
          appId,
          externalId,
        );
        break;
    }
  }

  private _addEventAnchor(): void {
    if (!this._eventAnchor) {
      this._eventAnchor = document.createElement("div");
      this._eventAnchor.id = "push-notifications-event-anchor";
      document.body.appendChild(this._eventAnchor);
    }
  }

  private _addEventListeners(): void {
    this._eventAnchor!.addEventListener(
      "onPushNotificationsAdapterInitiated",
      () => {
        console.log(
          "El adaptador de notificaciones push se ha iniciado correctamente.",
        );
        this._startPushNotificationProcess();
      },
    );

    this._eventAnchor!.addEventListener(
      "onPushNotificationsPermissionsChanged",
      (e: CustomEvent) => {
        this._handlePermissionChange(e.detail);
      },
    );
  }

  private _getUserExternalId(): string {
    return (
      localStorage.getItem("push_notification_external_id") ||
      this._setUserExternalId()
    );
  }

  private _setUserExternalId(): string {
    const externalId = this._utils.generateUUID();
    localStorage.setItem("push_notification_external_id", externalId);

    return externalId;
  }

  private _startPushNotificationProcess(): void {
    if (!this._provider!.isUserSubscribed()) {
      return;
    }

    if (!this._provider!.pushSubscriptionOptedIn) {
      this._provider!.requestPermission();
      return;
    }

    this._updateUserTags();
  }

  private _updateUserTags(): void {
    const userFormData = this._getUserFormData();
    const pushProviderUserData = this._getUserTags();
    const updates: UserTags = {};

    for (const [key, value] of Object.entries(userFormData)) {
      // Si la key no existe en pushProviderUserData o los valores son diferentes, añado key -> value
      if (
        !pushProviderUserData.hasOwnProperty(key) ||
        pushProviderUserData[key] !== value
      ) {
        updates[key] = value;
      }
    }

    if (Object.keys(updates).length > 0) {
      this._addUserTags(updates);
    }
  }

  private _getUserTags(): UserTags {
    return this._provider!.getTags();
  }

  private _addUserTags(tags: UserTags): void {
    this._provider!.addTags(tags);
  }

  // TODO: meter este código en un Util y reutilizarlo en User.js
  private _getUserFormData(): UserTags {
    let userFormData = Vault.get("u_form_data");
    if (userFormData !== false) {
      userFormData = JSON.parse(window.atob(userFormData));
      return userFormData;
    } else {
      return {};
    }
  }

  private _handlePermissionChange(permission: boolean): void {
    if (permission) {
      this._updateUserTags();
    } else {
      this._provider!.requestPermission();
    }
  }
}
